import { getErrorMessage } from '@onefootprint/fetch-hosted';
import { useEffect, useRef, useState } from 'react';
import Logger from '../../../utils/logger';
import type { HeicToModule } from '../types';
const IS_TEST = process.env.NODE_ENV === 'test';
const loadHeicToModule = async (retryCount = 0): Promise<HeicToModule> => {
  try {
    const {
      heicTo
    } = await import('heic-to');
    return ({
      blob,
      quality
    }) => heicTo({
      blob,
      type: 'image/jpeg',
      quality
    });
  } catch (_e) {
    if (retryCount < 2) {
      return loadHeicToModule(retryCount + 1);
    }
  }
  throw new Error('Failed to load heic-to library after multiple retries');
};
const useImportHeicTo = (): [boolean, HeicToModule | undefined] => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const ref = useRef<HeicToModule | undefined>(undefined);
  useEffect(() => {
    if (IS_TEST) {
      return;
    }
    loadHeicToModule().then(module => {
      ref.current = module;
      return module;
    }).catch(e => {
      // Losing this only drops HEIC from the accepted file formats, so there's nothing to act on
      // per occurrence.
      Logger.warn(`Failed to load heic-to library, ${getErrorMessage(e)}`);
    }).finally(() => setIsLoading(false));
  }, []);
  return [isLoading, ref.current];
};
export default useImportHeicTo;